<template>
  <div class="elevatorPortray">
    <div class="filters" style="text-align: right;">
      <!-- <div class="address">辽宁省沈阳市和平区 南京南街中土大厦</div>
      <div class="layBox">
        <div class="daysBox">
          <div class="daysNum">36</div>
          <div class="daysTxt">累计天数</div>
        </div>
        <el-button type="primary" @click="back">返回上一级</el-button>
      </div> -->
      <el-button type="primary" @click="back">返回上一级</el-button>
    </div>
    <div class="cardBox wid100">
      <!-- 电梯安全情况 -->
      <el-card class="cardFlex">
        <div class="cardFlexTitle">电梯安全情况</div>
        <div class="box">
          <div class="container">
            <div id="echart1"></div>
          </div>
          <el-tabs class="aaa" v-model="activeName1">
            <el-tab-pane label="汇总" name="1">
              <el-table :data="tableData1" style="width: 100%">
                <el-table-column prop="name" label="事件">
                </el-table-column>
                <el-table-column prop="value" label="次数" width="140">
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="日均" name="2">
              <el-table :data="tableData11" style="width: 100%">
                <el-table-column prop="name" label="事件">
                </el-table-column>
                <el-table-column prop="value" label="次数" width="140">
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-card>
      <!-- 电梯管理情况 -->
      <el-card class="cardFlex">
        <div class="cardFlexTitle">电梯管理情况</div>
        <div class="box">
          <div class="container">
            <div id="echart2"></div>
          </div>
          <el-tabs class="aaa" v-model="activeName2">
            <el-tab-pane label="汇总" name="1">
              <el-table :data="tableData2" style="width: 100%">
                <el-table-column prop="name" label="事件">
                </el-table-column>
                <el-table-column prop="value" label="次数" width="140">
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="日均" name="2">
              <el-table :data="tableData22" style="width: 100%">
                <el-table-column prop="name" label="事件">
                </el-table-column>
                <el-table-column prop="value" label="次数" width="140">
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-card>
      <!-- 电梯隐患情况 -->
      <!-- <el-card class="cardFlex">
        <div class="cardFlexTitle">电梯隐患情况</div>
        <div class="box">
          <div class="container">
            <div id="echart3"></div>
          </div>
          <el-tabs class="aaa" v-model="activeName3">
            <el-tab-pane label="汇总" name="1">
              <el-table :data="tableData3" style="width: 100%">
                <el-table-column prop="name" label="事件">
                </el-table-column>
                <el-table-column prop="value" label="次数" width="140">
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="日均" name="2">
              <el-table :data="tableData3" style="width: 100%">
                <el-table-column prop="name" label="事件">
                </el-table-column>
                <el-table-column prop="value" label="次数" width="140">
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-card> -->
      <!-- 电梯运行情况 -->
      <el-card class="cardFlex" style="margin-right: 0;">
        <div class="cardFlexTitle">电梯运行情况</div>
        <div class="box">
          <el-table :data="tableData4" style="width: 100%">
            <el-table-column prop="situation" label="运行情况">
            </el-table-column>
            <el-table-column prop="all" label="汇总" width="140">
            </el-table-column>
            <el-table-column prop="day" label="日均" width="140">
            </el-table-column>
          </el-table>
        </div>
      </el-card>
    </div>

  </div>
</template>

<script>
  /**
   *@ClassName:elevatorPortray
   *@Description:电梯物联网电梯画像
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2020-02-19
   */
  // import { mapGetters } from 'vuex'

  export default {
    name: '/manage/main.elevatorPortray',
    data() {
      return {
        liftId: '', // 电梯id
        activeName1: '1',
        activeName2: '1',
        activeName3: '1',
        tableData1: [{
          name: '电梯轿厢困人',
          value: '0',
        }, {
          name: '运行中开门',
          value: '0',
        }, {
          name: '轿厢意外移动',
          value: '0',
        }, {
          name: '轿厢在开锁区域外停止',
          value: '0',
        }, {
          name: '超速故障',
          value: '0',
        }, {
          name: '冲顶故障',
          value: '0',

        }, {
          name: '蹲底故障',
          value: '0',
        }, {
          name: '急停异常',
          value: '0',
        }], // 电梯安全情况表格数据(汇总)
        tableData11: [{
          name: '电梯轿厢困人',
          value: '0',
        }, {
          name: '运行中开门',
          value: '0',
        }, {
          name: '轿厢意外移动',
          value: '0',
        }, {
          name: '轿厢在开锁区域外停止',
          value: '0',
        }, {
          name: '超速故障',
          value: '0',
        }, {
          name: '冲顶故障',
          value: '0',

        }, {
          name: '蹲底故障',
          value: '0',
        }, {
          name: '急停异常',
          value: '0',
        }], // 电梯安全情况表格数据(日均)
        tableData2: [{
          name: '反复开关门',
          value: '0',
        }, {
          name: '长时间开门',
          value: '0',
        }, {
          name: '遮挡门',
          value: '0',
        }, {
          name: '异常震动',
          value: '0',
        }, {
          name: '无人高频运行',
          value: '0',
        }, {
          name: '长时间运行',
          value: '0',
        }], // 电梯管理情况表格数据(汇总)
        tableData22: [{
          name: '反复开关门',
          value: '0',
        }, {
          name: '长时间开门',
          value: '0',
        }, {
          name: '遮挡门',
          value: '0',
        }, {
          name: '异常震动',
          value: '0',
        }, {
          name: '无人高频运行',
          value: '0',
        }, {
          name: '长时间运行',
          value: '0',
        }], // 电梯管理情况表格数据(日均)
        // tableData3: [], // 电梯隐患情况表格数据(汇总)
        // tableData33: [], // 电梯隐患情况表格数据(日均)
        tableData4: [{
            situation: '电梯累计运行时间（分钟）',
            all: '0',
            day: '0',
          },
          {
            situation: '电梯累计运行次数（次）',
            all: '0',
            day: '0',
          }, {
            situation: '电梯累计开门次数（次）',
            all: '0',
            day: '0',
          }
        ], // 电梯运行情况表格数据
      }
    },
    watch: {
      activeName1(newValue, oldValue) {
        if (newValue == 1) {
          this.getLoadEcharts1(this.tableData1)
        } else if (newValue == 2) {
          this.getLoadEcharts1(this.tableData11)
        }
      },
      activeName2(newValue, oldValue) {
        if (newValue == 1) {
          this.getLoadEcharts2(this.tableData2)
        } else if (newValue == 2) {
          this.getLoadEcharts2(this.tableData22)
        }
      }
    },
    mounted() {
      console.log(this.$route.query.object)
      this.liftId = this.$route.query.object.Id
      this.getData()
    },
    methods: {
      // 返回上一级
      back() {
        this.$router.go(-1)
      },
      getData() {
        let loading = this.$loading()
        this.$get(
          `aapi/liftSecurity?liftId=${this.liftId}`
        ).then(
          res => {
            loading.close()
            console.log(res)
            if (res && res.errCode === 0) {
              this.tableData1.map((obj, index) => {
                switch (obj.name) {
                  case '电梯轿厢困人':
                    obj.value = res.callCount
                    break
                  case '运行中开门':
                    obj.value = res.runningOpenStateCount
                    break
                  case '轿厢意外移动':
                    obj.value = res.carriageAccidentMoveCount
                    break
                  case '轿厢在开锁区域外停止':
                    obj.value = res.carriageUnlockStopCount
                    break
                  case '超速故障':
                    obj.value = res.overSpeedFaultCount
                    break
                  case '冲顶故障':
                    obj.value = res.elevatortoppingCount
                    break
                  case '蹲底故障':
                    obj.value = res.elevatorCrouchingCount
                    break
                  case '急停异常':
                    obj.value = res.impatientStopErrorCount
                    break
                }
              })
              this.tableData11.map((obj, index) => {
                switch (obj.name) {
                  case '电梯轿厢困人':
                    obj.value = res.callAvg
                    break
                  case '运行中开门':
                    obj.value = res.runningOpenStateAvg
                    break
                  case '轿厢意外移动':
                    obj.value = res.carriageAccidentMoveAvg
                    break
                  case '轿厢在开锁区域外停止':
                    obj.value = res.carriageUnlockStopAvg
                    break
                  case '超速故障':
                    obj.value = res.overSpeedFaultAvg
                    break
                  case '冲顶故障':
                    obj.value = res.elevatortoppingAvg
                    break
                  case '蹲底故障':
                    obj.value = res.elevatorCrouchingAvg
                    break
                  case '急停异常':
                    obj.value = res.impatientStopErrorAvg
                    break
                }
              })
              this.tableData2.map((obj, index) => {
                switch (obj.name) {
                  case '反复开关门':
                    obj.value = res.repeatedOpenAndClosingCount
                    break
                  case '长时间开门':
                    obj.value = res.closethedoorinplaceCount
                    break
                  case '遮挡门':
                    obj.value = res.doorMalfunctionCount
                    break
                  case '异常震动':
                    obj.value = res.abnormalVibrationCount
                    break
                  case '无人高频运行':
                    obj.value = res.unmannedHighRunCount
                    break
                  case '长时间运行':
                    obj.value = res.longMovingCount
                    break
                }
              })
              this.tableData22.map((obj, index) => {
                switch (obj.name) {
                  case '反复开关门':
                    obj.value = res.repeatedOpenAndClosingAvg
                    break
                  case '长时间开门':
                    obj.value = res.closethedoorinplaceAvg
                    break
                  case '遮挡门':
                    obj.value = res.doorMalfunctionAvg
                    break
                  case '异常震动':
                    obj.value = res.abnormalVibrationAvg
                    break
                  case '无人高频运行':
                    obj.value = res.unmannedHighRunAvg
                    break
                  case '长时间运行':
                    obj.value = res.longMovingAvg
                    break
                }
              })
              this.tableData4.map((obj, index) => {
                switch (obj.situation) {
                  case '电梯累计运行时间（分钟）':
                    obj.all = res.runningTimeCount
                    obj.day = res.runningTimeAvg
                    break
                  case '电梯累计运行次数（次）':
                    obj.all = res.openTheDoorNumberCount
                    obj.day = res.openTheDoorNumberAvg
                    break
                  case '电梯累计开门次数（次）':
                    obj.all = res.openTheDoorNumberCount
                    obj.day = res.openTheDoorNumberAvg
                    break
                }
              })
              this.getLoadEcharts1(this.tableData1)
              this.getLoadEcharts2(this.tableData2)
            } else {
              this.$message.error(res.errMsg)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 获取电梯安全情况echarts图表
      getLoadEcharts1(data) {
        if (document.getElementById('echart1') == null) {
          return
        } else {
          this.$echarts.dispose(document.getElementById('echart1'))
        }
        var myChart1 = this.$echarts.init(
          document.getElementById('echart1')
        )
        var listData1 = data
        var option1 = {
          title: {},
          legend: {
            type: 'scroll', // 这里添加scroll就可以分页了
            orient: 'horizontal', // 水平
            bottom: 'bottom',
            left: 'center',
            data: listData1,
            align: 'auto',
            symbolKeepAspect: true,
            // icon: 'circle',
            itemGap: 10,
            selectedMode: true,
          },
          tooltip: {
            trigger: 'item'
          },
          series: [{
            type: 'pie',
            center: ['50%', '50%'],
            radius: '50%',
            minAngle: 15,
            label: {
              show: true,
              fontSize: 13,
              // color: 'inherit',
              formatter: function (data) {
                // return data.name + ':' + data.percent.toFixed(0) + '%'
              }
            },
            labelLine: {
              normal: {
                length: 15,
                length2: 15,
                lineStyle: {
                  width: 1
                }
              }
            },
            data: listData1
          }]
        }
        myChart1.setOption(option1)
      },
      // 获取电梯管理情况echarts图表
      getLoadEcharts2(data) {
        if (document.getElementById('echart2') == null) {
          return
        } else {
          this.$echarts.dispose(document.getElementById('echart2'))
        }
        var myChart2 = this.$echarts.init(
          document.getElementById('echart2')
        )
        var listData2 = data
        var option2 = {
          title: {},
          legend: {
            type: 'scroll',
            orient: 'horizontal',
            bottom: 'bottom',
            left: 'center',
            data: listData2,
            align: 'auto',
            symbolKeepAspect: true,
            itemGap: 10,
            selectedMode: true,
          },
          tooltip: {
            trigger: 'item'
          },
          series: [{
            type: 'pie',
            center: ['50%', '50%'],
            radius: '50%',
            minAngle: 15,
            label: {
              show: true,
              fontSize: 13,
              // color: '#000',
            },
            labelLine: {
              normal: {
                length: 15,
                length2: 15,
                lineStyle: {
                  width: 1
                }
              }
            },
            data: listData2
          }]
        }
        myChart2.setOption(option2)
      },
      // 获取电梯安全情况echarts图表
      getLoadEcharts3() {
        var myChart3 = this.$echarts.init(
          document.getElementById('echart3')
        )
        var listData3 = [{
          name: '故障数',
          value: 0
        }]
        var option3 = {
          title: {},
          legend: {
            type: 'scroll',
            orient: 'horizontal',
            bottom: 'bottom',
            left: 'center',
            data: listData3,
            align: 'auto',
            symbolKeepAspect: true,
            itemGap: 10,
            selectedMode: true,
          },
          tooltip: {
            trigger: 'item'
          },
          series: [{
            type: 'pie',
            center: ['50%', '50%'],
            radius: '50%',
            minAngle: 15,
            label: {
              show: true,
              fontSize: 13,
              // color: '#000',
            },
            labelLine: {
              normal: {
                length: 15,
                length2: 15,
                lineStyle: {
                  width: 1
                }
              }
            },
            data: listData3
          }]
        }
        myChart3.setOption(option3)
      }
    }
  }
</script>

<style lang="scss">
  .elevatorPortray {
    .filters {
      .address {
        font-size: 18px;
        padding-left: 10px;
        border-left: 3px solid #ff6207;
      }

      .layBox {
        display: flex;
        justify-content: space-between;

        .daysBox {
          width: 20%;
          text-align: center;
          margin-top: 20px;

          .daysNum {
            font-size: 26px;
            font-weight: bold;
            color: #00b1c3;
            margin-bottom: 10px;
          }

          .daysTxt {
            font-size: 18px;
          }
        }
      }
    }

    .cardBox {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }

    .cardFlex {
      flex: 1 0 40%;
      align-items: center;
      margin-right: 2%;
      margin-bottom: 2%;

      .cardFlexTitle {
        font-size: 18px;
        padding-left: 10px;
        margin-left: 10px;
        margin-bottom: 30px;
        border-left: 3px solid #ff6207;
      }
    }

    .cardFlex:nth-child(2n+2) {
      margin-right: 0;
    }

    .box {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }

    .el-tabs {
      flex: 1;
      margin-bottom: 50px;
      background-color: #fff !important;
    }

    .aaa .el-tabs__nav-wrap {
      position: static !important;
      background-color: #fff;
      max-width: 100%
    }

    .el-tabs__nav-wrap::after {
      display: none;
    }

    .el-tabs__nav-scroll .el-tabs__nav.is-top .el-tabs__item:nth-last-child(2) {
      padding-left: 20px !important;
      border: none !important;
    }

    .el-tabs__nav-scroll .el-tabs__nav.is-top .el-tabs__item:last-child {
      padding-right: 20px !important;
      border: none !important;
    }

    .container {
      width: 19vw;
      height: 400px;
      margin-left: 30px;
    }

    #echart1 {
      width: 100%;
      height: 100%;
    }

    #echart2 {
      width: 100%;
      height: 100%;
    }

    #echart3 {
      width: 100%;
      height: 100%;
    }

  }
</style>